import {Box, Button} from '@dagster-io/ui-components';
import {ComponentProps, ForwardedRef, ReactNode, forwardRef} from 'react';

import styles from '@/components/css/CenteredButton.module.css';
interface Props extends ComponentProps<typeof Button> {
  label: ReactNode;
}

const CenteredButton = forwardRef<HTMLButtonElement, Props>(
  ({icon, label, ...rest}: Props, ref: ForwardedRef<HTMLButtonElement>) => {
    return (
      <Button {...rest} ref={ref} className={styles.button}>
        <Box flex={{direction: 'row', gap: 4, alignItems: 'center'}}>
          {icon}
          <span>{label}</span>
        </Box>
      </Button>
    );
  },
);

export default CenteredButton;
